import { render, staticRenderFns } from "./StorageQuestionEdit.vue?vue&type=template&id=18db3906&scoped=true&"
import script from "./StorageQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./StorageQuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./StorageQuestionEdit.vue?vue&type=style&index=0&id=18db3906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db3906",
  null
  
)

export default component.exports